module.exports = __webpack_public_path__ + "static/media/400078_01.e5dff7b1.png";